import { Injectable } from "@angular/core"
import { BreakpointObserver } from '@angular/cdk/layout'
import { Observable } from "rxjs"
import { map } from "rxjs/operators"

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
type BreakpointDirection = 'isOver' | 'isUnder'

@Injectable({providedIn: 'root'})

export class MediaQueryService {
  breakpoints: {[key in Breakpoint]: string} = {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  };

  constructor(private breakpointObserver: BreakpointObserver) {}

  // ex: mediaQuery.isUnder('lg')
  isUnder(breakpoint: Breakpoint): boolean {
    return this.breakpointObserver.isMatched(`(max-width: ${this.breakpoints[breakpoint]})`)
  }

  // ex: mediaQuery.isOver('md')
  isOver(breakpoint: Breakpoint): boolean {
    return this.breakpointObserver.isMatched(`(min-width: ${this.breakpoints[breakpoint]})`)
  }

  observeBreakpoint(direction: BreakpointDirection, breakpoint: Breakpoint): Observable<boolean> {
    return this.breakpointObserver.observe(`(${this.widthDescriptor(direction)}: ${this.breakpoints[breakpoint]})`).pipe(
      map(state => state.matches)
    )
  }

  /**
   * Example usage
   * this.mediaQueryService.observeBreakpointState([
   *  { direction: 'isOver', breakpoint: 'md' },
   *  { direction: 'isUnder', breakpoint: 'lg' }
   * ]).subscribe(([isOverMd, isUnderLg]) => this.isMediumScreen = isOverMd && isUnderLg)
   */
  observeBreakpoints(matchers: {direction: BreakpointDirection, breakpoint: Breakpoint}[]): Observable<boolean[]> {
    return this.breakpointObserver.observe([
      ...matchers.map(({direction, breakpoint}) => `(${this.widthDescriptor(direction)}: ${this.breakpoints[breakpoint]})`)
    ]).pipe(map(state => Object.values(state.breakpoints)))
  }

  private widthDescriptor(direction: BreakpointDirection): string {
    return direction === 'isOver' ? 'min-width' : 'max-width'
  }
}
